import React from 'react'
import PropTypes from 'prop-types'

import { Card } from '@offerzen/pinata'

import JobCardHeader from '@/CandidateExperience/components/JobCardHeader'

import CardBody from './CardBody'
import styles from './styles'

const JobCard = ({ job }) => {
  const {
    companyProfileBrandColor,
    companyProfileImage,
    companyProfileName,
    companyProfileSlug,
    name,
    roleExperience,
    otherRoles,
    mustHaveSkillExperiences,
    workplacePolicy,
    publishedSalaryRange,
    currency,
    remunerationPeriod,
    id,
  } = job

  return (
    <Card className={styles.card}>
      <JobCardHeader
        companyImage={companyProfileImage}
        companyBrandColor={companyProfileBrandColor}
        companyName={companyProfileName}
        jobTitle={name}
        jobDetailsHref={`recommended-jobs/${id}?show_feedback_form`}
      />
      <CardBody
        companyName={companyProfileName}
        companyProfileSlug={companyProfileSlug}
        jobTitle={name}
        jobId={id}
        roleExperience={roleExperience}
        otherRoles={otherRoles}
        mustHaveSkillExperiences={mustHaveSkillExperiences}
        workplacePolicy={workplacePolicy}
        publishedSalaryRange={publishedSalaryRange}
        currency={currency}
        remunerationPeriod={remunerationPeriod}
      />
    </Card>
  )
}

JobCard.propTypes = {
  job: PropTypes.shape({
    companyProfileImage: PropTypes.string,
    companyProfileBrandColor: PropTypes.string,
    companyProfileName: PropTypes.string,
    companyProfileSlug: PropTypes.string,
    name: PropTypes.string,
    workplacePolicy: PropTypes.shape({}),
    publishedSalaryRange: PropTypes.shape({}),
    currency: PropTypes.shape({}),
    remunerationPeriod: PropTypes.oneOf(['MONTH', 'YEAR']),
    roleExperience: PropTypes.shape({}),
    otherRoles: PropTypes.arrayOf(PropTypes.shape({})),
    mustHaveSkillExperiences: PropTypes.arrayOf(PropTypes.shape({})),
    id: PropTypes.string,
  }),
}

export default JobCard
